/* @jsxImportSource @emotion/react */
import React from 'react';
import { observer } from 'mobx-react';
import { Container, UseButtonStyle } from './styled';
import { AppRouter, AppRoute } from '@ice/stark';
import NotFound from '@/components/Loading/NotFound';
import PageLoading from '@/components/Loading/PageLoading';
import { getAppSystemList } from '../Common/method';
import UseButton from '@/components/commonComps/Use/UseButton';
import { usePush } from '../Common/hook';
const Page = () => {
  const { replaceUrl } = usePush(false);
  const handleRouteChange = (pathname: any) => {
    console.log('route change', pathname);
    // 如有需求，可根据 pathname 切换 layout 的形态
  };
  return (
    <Container>
      {/* <UseButtonStyle onClick={() => replaceUrl('/Home')}>回到首页</UseButtonStyle> */}
      <AppRouter
        NotFoundComponent={NotFound}
        LoadingComponent={PageLoading}
        onRouteChange={handleRouteChange}
        prefetch>
        {getAppSystemList().map((item, index) => {
          return (
            <AppRoute
              key={index}
              path={item.phoneBaseUrl}
              title={item.name}
              entry={item.phoneEntryUrl}
            />
          );
        })}
      </AppRouter>
    </Container>
  );
};

export default observer(Page);
